/* eslint-disable */
'use strict';

if (typeof module !== 'undefined') module.exports = simpleshot;

function simpleshot(canvas) {
    if (!(this instanceof simpleshot)) return new simpleshot(canvas);
    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas;
    // console.log(this._canvas)
    this._ctx = canvas.getContext('2d');
    this._width = canvas.width;
    this._height = canvas.height;

    this._max = 1;
    this._data = [];
}

simpleshot.prototype = {

    defaultRadius: 5,

    data: function (data) {
        this._data = data;
        return this;
    },

    max: function (max) {
        this._max = max;
        return this;
    },

    resize: function () {
        this._width = this._canvas.width;
        this._height = this._canvas.height;
    },
    drawCircle: function(ctx, posX, posY, radius=1, color='black')
    {
        ctx.shadowOffsetX = ctx.shadowOffsetY = .8;
        ctx.shadowBlur = 4;
        ctx.shadowColor = 'rgb(0, 0, 0)';
        ctx.fillStyle = color
        ctx.beginPath();
        ctx.arc(posX, posY, radius, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return this;
    },

    render: function () {
        
        var ctx = this._ctx;

        ctx.clearRect(0, 0, this._width, this._height);
        // Draw background
        ctx.beginPath();
        ctx.rect(0, 0, this._width, this._height);
        ctx.fillStyle = 'rgba(254, 254, 254, 0.02)';
        ctx.fill();
        for (var i = 0, len = this._data.length, p; i < len; i++) {
            p = this._data[i];

            this.drawCircle(ctx, p[0], p[1], p[3], p[4])
        }
        var map = ctx.getImageData(0, 0, this._width, this._height);
        ctx.putImageData(map, 0, 0);

        return this;
    },

    _createCanvas: function () {
        if (typeof document !== 'undefined') {
            return document.createElement('canvas');
        } else {
            // create a new canvas instance in node.js
            // the canvas class needs to have a default constructor without any parameter
            return new this._canvas.constructor();
        }
    }
};


// WEBPACK FOOTER //
// ./client/store/modules/simpleheat/simpleshot.js